import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAuthenticatedSWR } from '../api';
import { OFFER_URL, REACTIVATION_CODE_TYPE } from './constants';
import { getFormattedOfferAmountByType } from './helpers';

export const useMxDiscount = () => {
  const [queryOfferCode, setQueryOfferCode] = useState(null);
  const [invalidQueryCodes, setInvalidQueryCodes] = useState([]);
  const searchParams = useSearchParams();

  useEffect(() => {
    const offerCodeParam = searchParams?.get('offer_code');

    if (offerCodeParam) {
      setQueryOfferCode(offerCodeParam);
    }
  }, [searchParams]);

  const codeMightBeValid =
    !!queryOfferCode && !invalidQueryCodes.includes(queryOfferCode);

  const { data, error } = useAuthenticatedSWR(
    queryOfferCode ? `${OFFER_URL}${queryOfferCode}/` : null,
  );

  useEffect(() => {
    if (codeMightBeValid && error) {
      setInvalidQueryCodes(prevCodes => [...prevCodes, queryOfferCode]);
      setQueryOfferCode(null);
    }
  }, [codeMightBeValid, error, queryOfferCode]);

  const dataCompleteWithCode = data?.code
    ? data
    : { ...data, code: queryOfferCode };
  const isReactivationType =
    dataCompleteWithCode?.category === REACTIVATION_CODE_TYPE;

  return {
    loading: queryOfferCode ? !data && !error : false,
    data: {
      ...dataCompleteWithCode,
      isReactivationType,
      formattedAmount: getFormattedOfferAmountByType(dataCompleteWithCode),
    },
    invalidQueryCodes,
  };
};
